import { render, staticRenderFns } from "./RevisionEstudiantes.vue?vue&type=template&id=41cb4b45&scoped=true"
import script from "./RevisionEstudiantes.vue?vue&type=script&lang=js"
export * from "./RevisionEstudiantes.vue?vue&type=script&lang=js"
import style0 from "./RevisionEstudiantes.vue?vue&type=style&index=0&id=41cb4b45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41cb4b45",
  null
  
)

export default component.exports